import React, { useState, useEffect } from 'react';
import { myFirestore } from '../../../services/firebase'
import Container from "react-bootstrap/Container";
import { Button, Row, Col } from "react-bootstrap";
import "./BlogsSection.css";
import {Blogslist} from '../../Blogs/Blogs'
// function BlogCard(props) {
//   return (
//     <Col md={6} lg={4}>
//       <Card>
//         <Card.Body>
//           <Card.Title>{props.title}</Card.Title>
//           <Card.Subtitle className="mb-2 text-muted">
//             <div>
//               <p>{props.author}</p>
//               <p>{props.publishtime}</p>
//             </div>
//           </Card.Subtitle>
//           <Card.Text>{props.content}</Card.Text>
//         </Card.Body>
//         <Card.Footer>
//           <i class="far fa-eye"> {props.likes}</i>
//           <Button variant="primary" className="readmore">
//             Read More
//           </Button>
//         </Card.Footer>
//       </Card>
//     </Col>
//   );
// }

export function BlogsSection (props)  {
  const [blogsList, setblogsList] = useState([])

  const readBlogs = () => {
    myFirestore.collection('blogs').get()
      .then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          // doc.data() is never undefined for query doc snapshots
          console.log(doc.id, " => ", doc.data());
          setblogsList(blogsList => [...blogsList, doc.data()])

        });
      })
      .catch(function (error) {
        console.log("Error getting documents: ", error);

      });
  }
  useEffect(() => {
    readBlogs()
  }, []);
  return (
   
  <Container fluid className="blogs">
    <Row
      lg="3"
      sm="3"
      xs="3"
      className="text-center justify-content-center"
      style={{ padding: "5rem" }}
    >
      <Col lg="2">
        <hr />
      </Col>
      <Col lg="3">
        <p className="blog-section-heading"> Latest Blogs</p>
      </Col>
      <Col lg="2">
        <hr />
      </Col>
    </Row>
     
 
    {blogsList?<Blogslist blogsList={blogsList}/>:null}
    <Row
      
      className="text-center justify-content-center"
      style={{ paddingTop:'2rem' }}
    >
    <Button  variant="primary" className="readmore" href='/blogs'>
            Read More
          </Button>
          </Row>
  </Container>
  
  );
};
